import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getFontesDados as getFontesDadosSdk,
  getFonteDado as getFonteDadoSdk,
  postFonteDado as postFonteDadoSdk,
  putFonteDado as putFonteDadoSdk,
} from '@sdk/Conectores/FontesDados';

//Action Types
export const Types = {
  GET_FONTES_DADOS: 'GET_FONTES_DADOS',
  GET_FONTES_DADOS_SUCCESS: 'GET_FONTES_DADOS_SUCCESS',
  GET_FONTES_DADOS_ERROR: 'GET_FONTES_DADOS_ERROR',

  GET_FONTE_DADO: 'GET_FONTE_DADO',
  GET_FONTE_DADO_SUCCESS: 'GET_FONTE_DADO_SUCCESS',
  GET_FONTE_DADO_ERROR: 'GET_FONTE_DADO_ERROR',

  POST_FONTE_DADO: 'POST_FONTE_DADO',
  POST_FONTE_DADO_SUCCESS: 'POST_FONTE_DADO_SUCCESS',
  POST_FONTE_DADO_ERROR: 'POST_FONTE_DADO_ERROR',

  PUT_FONTE_DADO: 'PUT_FONTE_DADO',
  PUT_FONTE_DADO_SUCCESS: 'PUT_FONTE_DADO_SUCCESS',
  PUT_FONTE_DADO_ERROR: 'PUT_FONTE_DADO_ERROR',

  RESET_FONTES_DADOS: 'RESET_FONTES_DADOS',
};

//Action Creators
export const getFontesDados = (idConfiguracao) => ({ type: Types.GET_FONTES_DADOS, idConfiguracao });
export const getFontesDadosSuccess = (data) => ({ type: Types.GET_FONTES_DADOS_SUCCESS, data });
export const getFontesDadosError = (error) => ({ type: Types.GET_FONTES_DADOS_ERROR, error });

export const getFonteDado = (idConfiguracao, id) => ({ type: Types.GET_FONTE_DADO, idConfiguracao, id });
export const getFonteDadoSuccess = (data) => ({ type: Types.GET_FONTE_DADO_SUCCESS, data });
export const getFonteDadoError = (error) => ({ type: Types.GET_FONTE_DADO_ERROR, error });

export const postFonteDado = (data) => ({ type: Types.POST_FONTE_DADO, data });
export const postFonteDadoSuccess = () => ({ type: Types.POST_FONTE_DADO_SUCCESS });
export const postFonteDadoError = (error) => ({ type: Types.POST_FONTE_DADO_ERROR, error });

export const putFonteDado = (data) => ({ type: Types.PUT_FONTE_DADO, data });
export const putFonteDadoSuccess = () => ({ type: Types.PUT_FONTE_DADO_SUCCESS });
export const putFonteDadoError = (error) => ({ type: Types.PUT_FONTE_DADO_ERROR, error });

export const reset = () => ({ type: Types.RESET_FONTES_DADOS });

//saga
function* fetchGetFontesDados(action) {
  try {
    const { idConfiguracao } = action;
    const fontesDados = yield call(getFontesDadosSdk, idConfiguracao);
    yield put(getFontesDadosSuccess(fontesDados));
  } catch (err) {
    Notification.error(err.message);
    yield put(getFontesDadosError(err));
  }
}

function* fetchGetFonteDado(action) {
  try {
    const { idConfiguracao, id } = action;
    const fonteDado = yield call(getFonteDadoSdk, idConfiguracao, id);
    yield put(getFonteDadoSuccess(fonteDado));
  } catch (err) {
    Notification.error(err.message);
    yield put(getFonteDadoError(err));
  }
}

function* fetchPostFonteDado(action) {
  try {
    const { data } = action;
    yield call(postFonteDadoSdk, data);
    yield put(postFonteDadoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postFonteDadoError(err));
  }
}

function* fetchPutFonteDado(action) {
  try {
    const { data } = action;
    yield call(putFonteDadoSdk, data);
    yield put(putFonteDadoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putFonteDadoError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_FONTES_DADOS, fetchGetFontesDados),
  takeLatest(Types.GET_FONTE_DADO, fetchGetFonteDado),
  takeLatest(Types.POST_FONTE_DADO, fetchPostFonteDado),
  takeLatest(Types.PUT_FONTE_DADO, fetchPutFonteDado),
];

// Reducer
const initialState = Map({
  fontesDados: List(),
  fonteDado: {},

  loadingFontesDados: false,
  successFontesDados: false,
  errorFontesDados: false,

  loadingFonteDado: false,
  successFonteDado: false,
  errorFonteDado: false,

  postingFonteDado: false,
  successPostFonteDado: false,
  errorPostFonteDado: false,

  putingFonteDado: false,
  successPutFonteDado: false,
  errorPutFonteDado: false,
});

const handleGetFontesDados = (state, action) => {
  return state.set('loadingFontesDados', true).set('successFontesDados', false).set('errorFontesDados', false);
};

const handleGetFontesDadosSuccess = (state, action) => {
  const fontesDados = action.data;

  return state
    .set('fontesDados', List(fontesDados))
    .set('loadingFontesDados', false)
    .set('successFontesDados', true)
    .set('errorFontesDados', false);
};

const handleGetFontesDadosError = (state, action) => {
  return state.set('loadingFontesDados', false).set('successFontesDados', false).set('errorFontesDados', action.error);
};

const handleGetFonteDado = (state, action) => {
  return state.set('loadingFonteDado', true).set('successFonteDado', false).set('errorFonteDado', false);
};

const handleGetFonteDadoSuccess = (state, action) => {
  const fonteDado = action.data[0];
  return state.set('fonteDado', fonteDado).set('loadingFonteDado', false).set('successFonteDado', true).set('errorFonteDado', false);
};

const handleGetFonteDadoError = (state, action) => {
  return state.set('loadingFonteDado', false).set('successFonteDado', false).set('errorFonteDado', action.error);
};

const handlePostFonteDado = (state, action) => {
  return state.set('postingFonteDado', true).set('successPostFonteDado', false).set('errorPostFonteDado', false);
};

const handlePostFonteDadoSuccess = (state, action) => {
  return state.set('postingFonteDado', false).set('successPostFonteDado', true).set('errorPostFonteDado', false);
};

const handlePostFonteDadoError = (state, action) => {
  return state.set('postingFonteDado', false).set('successPostFonteDado', false).set('errorPostFonteDado', action.error);
};

const handlePutFonteDado = (state, action) => {
  return state.set('putingFonteDado', true).set('successPutFonteDado', false).set('errorPutFonteDado', false);
};

const handlePutFonteDadoSuccess = (state, action) => {
  return state.set('putingFonteDado', false).set('successPutFonteDado', true).set('errorPutFonteDado', false);
};

const handlePutFonteDadoError = (state, action) => {
  return state.set('putingFonteDado', false).set('successPutFonteDado', false).set('errorPutFonteDado', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_FONTES_DADOS:
      return handleGetFontesDados(state, action);
    case Types.GET_FONTES_DADOS_SUCCESS:
      return handleGetFontesDadosSuccess(state, action);
    case Types.GET_FONTES_DADOS_ERROR:
      return handleGetFontesDadosError(state, action);

    case Types.GET_FONTE_DADO:
      return handleGetFonteDado(state, action);
    case Types.GET_FONTE_DADO_SUCCESS:
      return handleGetFonteDadoSuccess(state, action);
    case Types.GET_FONTE_DADO_ERROR:
      return handleGetFonteDadoError(state, action);

    case Types.POST_FONTE_DADO:
      return handlePostFonteDado(state, action);
    case Types.POST_FONTE_DADO_SUCCESS:
      return handlePostFonteDadoSuccess(state, action);
    case Types.POST_FONTE_DADO_ERROR:
      return handlePostFonteDadoError(state, action);

    case Types.PUT_FONTE_DADO:
      return handlePutFonteDado(state, action);
    case Types.PUT_FONTE_DADO_SUCCESS:
      return handlePutFonteDadoSuccess(state, action);
    case Types.PUT_FONTE_DADO_ERROR:
      return handlePutFonteDadoError(state, action);

    case Types.RESET_FONTES_DADOS:
      return handleReset(state, action);

    default:
      return state;
  }
}
